(function () {
  const root = document.querySelector("[data-designers-directory]");
  if (!root) return;

  const input = root.querySelector("[data-designer-search]");
  const tabs = Array.from(root.querySelectorAll(".designers-directory__tab[data-scope]"));
  const vendorLinks = Array.from(root.querySelectorAll("[data-vendor-link]"));
  const items = Array.from(root.querySelectorAll("[data-designer-item]"));
  const letterLinks = Array.from(root.querySelectorAll("[data-letter-filter]"));

  const namespace = root.getAttribute("data-mf-namespace") || "custom";
  const deptKey = root.getAttribute("data-mf-department-key") || "departamento";
  const genderKey = root.getAttribute("data-mf-gender-key") || "gender";

  const vendorScopeMap = new Map();

  const scopeScript = document.getElementById("vendor-scope-data");
  if (scopeScript) {
    try {
      const linesStr = JSON.parse(scopeScript.textContent || '""');
      const lines = (linesStr || "")
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);

      lines.forEach((row) => {
        const [vendor, dept, gender] = row.split("|").map((s) => (s || "").trim());
        if (!vendor || !dept || !gender) return;

        if (!vendorScopeMap.has(vendor)) {
          vendorScopeMap.set(vendor, { dept: new Set(), gender: new Set() });
        }

        const entry = vendorScopeMap.get(vendor);
        entry.dept.add(dept);
        entry.gender.add(gender);
      });
    } catch (e) {
      console.warn("vendor scope data parse failed", e);
    }
  }

  function normalize(str) {
    return (str || "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function getVendorName(item) {
    const link = item.querySelector("[data-vendor-link]");
    if (link) {
      return (
        link.getAttribute("data-vendor") ||
        item.getAttribute("data-designer-name") ||
        item.getAttribute("data-name") ||
        link.textContent ||
        ""
      ).trim();
    }

    return (
      item.getAttribute("data-designer-name") ||
      item.getAttribute("data-name") ||
      item.textContent ||
      ""
    ).trim();
  }

  function getSearchableName(item) {
    return normalize(
      item.getAttribute("data-designer-name") ||
      item.getAttribute("data-name") ||
      getVendorName(item)
    );
  }

  function getItemLetter(item) {
    return normalize(item.getAttribute("data-letter") || "");
  }

  function buildHref(vendor, scope) {
    const url = new URL("/collections/all", window.location.origin);

    url.searchParams.set("filter.p.vendor", vendor);

    if (scope?.dept) {
      url.searchParams.set(`filter.p.m.${namespace}.${deptKey}`, scope.dept);
    }

    if (scope?.gender) {
      url.searchParams.set(`filter.p.m.${namespace}.${genderKey}`, scope.gender);
    }

    return url.pathname + "?" + url.searchParams.toString();
  }

  function vendorMatchesScope(vendor, scope) {
    if (!vendorScopeMap.size) return true;

    const entry = vendorScopeMap.get(vendor);
    if (!entry) return false;

    if (scope?.dept && !entry.dept.has(scope.dept)) return false;
    if (scope?.gender && !entry.gender.has(scope.gender)) return false;

    return true;
  }

  function updateGroupsVisibility() {
    const groups = Array.from(root.querySelectorAll("[data-letter-group]"));
    if (!groups.length) return;

    groups.forEach((group) => {
      const groupItems = Array.from(group.querySelectorAll("[data-designer-item]"));
      const anyVisible = groupItems.some((item) => !item.classList.contains("is-hidden"));
      group.classList.toggle("is-empty", !anyVisible);
    });
  }

  function updateVendorLinks() {
    vendorLinks.forEach((link) => {
      const vendor = (link.getAttribute("data-vendor") || link.textContent || "").trim();
      if (!vendor) return;

      link.setAttribute("href", buildHref(vendor, currentScope));
    });
  }

  function setActiveLetter(letter) {
    currentLetter = letter || "all";

    letterLinks.forEach((link) => {
      const active = (link.getAttribute("data-letter-filter") || "") === currentLetter;
      link.classList.toggle("is-active", active);
    });

    applyFilters();
  }

  function applyFilters() {
    const q = normalize(input?.value || "");

    items.forEach((item) => {
      const vendorName = getVendorName(item);
      const searchableName = getSearchableName(item);
      const itemLetter = getItemLetter(item);

      const matchSearch = !q || searchableName.includes(q);
      const matchScope = vendorMatchesScope(vendorName, currentScope);
      const matchLetter = currentLetter === "all" || itemLetter === currentLetter;

      item.classList.toggle("is-hidden", !(matchSearch && matchScope && matchLetter));
    });

    updateGroupsVisibility();
  }

  function setActiveTab(btn) {
    if (!btn) return;

    tabs.forEach((b) => {
      const active = b === btn;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-selected", active ? "true" : "false");
    });

    try {
      currentScope = JSON.parse(btn.getAttribute("data-scope") || "{}");
    } catch (e) {
      currentScope = { dept: "", gender: "" };
    }

    updateVendorLinks();

    if (input) input.value = "";
    setActiveLetter("all");
  }

  function hexToRgb(hex) {
    const clean = (hex || "").replace("#", "");
    const full = clean.length === 3
      ? clean.split("").map((c) => c + c).join("")
      : clean;

    const num = parseInt(full, 16);

    return {
      r: (num >> 16) & 255,
      g: (num >> 8) & 255,
      b: num & 255
    };
  }

  function getContrastColor(hex) {
    const { r, g, b } = hexToRgb(hex);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.62 ? "#111111" : "#ffffff";
  }

  function assignDesktopHoverColors() {
    const desktopCards = Array.from(
      root.querySelectorAll(".designers-directory__desktop-grid .designers-directory__card")
    );

    if (!desktopCards.length) {
      console.warn("No desktop cards found for hover colors");
      return;
    }

   const popeyesPalette = [
"#FF003C",
"#FF6B00",
"#FFD400",
"#00FF85",
"#00D9FF",
"#0066FF",
"#8B00FF",
"#FF00E5",
"#FF0059",
"#FF3B00",
"#FF9100",
"#FFE600",
"#00FFB7",
"#00CFFF",
"#0055FF",
"#6F00FF",
"#FF00C3",
"#FF0044",
"#FF5200",
"#FFB800",
"#F5FF00",
"#00FF66",
"#00F0FF",
"#0048FF",
"#7A00FF",
"#FF0095",
"#FF0022",
"#FF7B00",
"#FFC400",
"#EAFF00",
"#00FF48",
"#00E5FF",
"#003CFF",
"#6800FF",
"#FF0077",
"#FF0011",
"#FF9900",
"#FFD900",
"#CCFF00",
"#00FF2F",
"#00D1FF",
"#002BFF",
"#4B00FF",
"#FF0055",
"#FF3F00",
"#FFAD00",
"#FFE100",
"#B8FF00",
"#00FF1A",
"#00BFFF",
"#001AFF"
];

    desktopCards.forEach((card, index) => {
      const color = popeyesPalette[index % popeyesPalette.length];
      const contrast = getContrastColor(color);

      card.style.setProperty("--card-hover-bg", color);
      card.style.setProperty("--card-hover-fg", contrast);
    });
  }

  let currentScope = { dept: "", gender: "" };
  let currentLetter = "all";

  if (tabs.length) {
    tabs.forEach((btn) => {
      btn.addEventListener("click", () => setActiveTab(btn));
    });
  }

  if (input) {
    input.addEventListener("input", applyFilters);
  }

  if (letterLinks.length) {
    letterLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const letter = link.getAttribute("data-letter-filter") || "all";
        setActiveLetter(letter);
      });
    });
  }

  if (tabs.length) {
    const initial = tabs.find((t) => t.classList.contains("is-active")) || tabs[0];
    setActiveTab(initial);
  } else {
    updateVendorLinks();
    applyFilters();
  }

  assignDesktopHoverColors();
})();